class e extends Error {
}
export {
  e as NoResponseError
};
